import NextLink from 'next/link'

type NextLinkProps = Parameters<typeof NextLink>['0']

export const Link = ({ children, ...props }: NextLinkProps) => {
  // Note: Disable prefetch for account links to prevent issues with middleware auth checks
  const isAccountLink = props.href.toString().includes('/account')

  return (
    <NextLink {...props} prefetch={isAccountLink ? false : true}>
      {children}
    </NextLink>
  )
}
